<template>
    <div class="text-center mt-5 mb-5">
        <v-progress-circular
            :size="size ? size : 70"
            :width="7"
            color="#76be1a"
            indeterminate
        ></v-progress-circular>
    </div>
</template>

<script>
    export default {
        name: "Loading",

        props: {
            size: Number,
        },
    }
</script>

<style scoped>
</style>
